import type { GatsbyBrowser } from "gatsby"
import "./global.css"

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  // Delay so the new page's <title> has been committed to the DOM before
  // goatcounter reads document.title — otherwise it records the previous page's title.
  setTimeout(() => {
    const goatcounter = (window as any).goatcounter
    if (goatcounter?.count) {
      goatcounter.count({ path: location.pathname + location.search })
    }
  }, 50)
}
